import {FetchHandler} from "../../../infrastructure/handlers/fetch-handler";
import {RaffleBookmakerDataSource} from "../../../domain/raffle-bookmaker/models/raffle-bookmaker.data-source";
import {BolaoSettingsDomainService} from "../../../domain/bolao-settings/services/bolao-settings.domain-service";
import type {WebsiteModuleController} from "../website-module.controller";
import type {WebsiteModuleState} from "../models/website-module.state";
import {BolaoSettingsRequestParams} from "../../../domain/bolao-settings/models/bolao-settings.request-params";
import type {BolaoSettingsDataSource} from "../../../domain/bolao-settings/models/bolao-settings-data.source";
import {APP} from "../../../core/app/consts";
import {autorun} from "mobx";
import {BOLAO} from "../../../core/consts";

export class WebsiteModuleBolaoSettingsFetchHandler extends FetchHandler {
  controller: WebsiteModuleController;
  state: WebsiteModuleState;
  type = APP.ACTION_TYPES.fetchBolaoSettings

  static injectables = [BolaoSettingsDomainService];

  async onLoaded(): Promise<*> {
    await super.onLoaded();

    autorun(() => this.appStore.state.appBolaoDisplayModel.isNavigationsVisible && this.action());
  }

  get requestParams(): BolaoSettingsRequestParams {
    const userCountryId: Number = this.appStore.state.locale.userCountryId;
    const languageId: Number = this.appStore.state.locale.language.id;
    const environment: String = BOLAO.ENVIRONMENTS.prod;
    const requestParams: BolaoSettingsRequestParams = new BolaoSettingsRequestParams(environment, languageId, userCountryId);

    return requestParams;
  }

  async action(): Promise<RaffleBookmakerDataSource> {
    const dataSource: BolaoSettingsDataSource = await this.fetch();

    this.appStore.state.bolaoSettings = dataSource;
  }
}
